import { cloneDeep, isEqual } from 'lodash'

import { generateServices, globalErrorHandler, permissionPresets } from '@/utils'

import render from './render'

export default function(options = {}) {
  return {
    name: 'LegacyTemplate',

    mixins: [ generateServices(options) ],

    data() {
      return {
        show: false,

        formValidation: true,
        titleValidation: true,

        initialData: undefined,

        updateSuccessKey: 0
      }
    },

    computed: {
      canGet() {
        return this.checkPermissions(`advanced.${options.name}.get`, permissionPresets.resellerUp)
      },
      canUpdate() {
        return this.checkPermissions(`advanced.${options.name}.update`, permissionPresets.resellerUp)
      },
      canRemove() {
        return this.checkPermissions(`advanced.${options.name}.remove`, permissionPresets.resellerUp)
      },
      dataIsEqual() {
        return isEqual(cloneDeep(this.initialData), cloneDeep(this.restData[options.name].get.data))
      },
      updateDisabled() {
        // NOTE: https://sigmasms.slack.com/archives/C03RRLZB8MP/p1777468298939649
        return this.restData[options.name].update.state === 'loading' || !this.canUpdate || !this.validation/*  || this.dataIsEqual */
      },
      validation() {
        return this.formValidation && this.titleValidation
      }
    },

    watch: {
      async '$route.params.id'() {
        await this.$nextTick(() => {
          return this.scrollToTop()
        })
        await this.getById()
      }
    },

    async mounted() {
      await this.$nextTick(() => {
        return this.scrollToTop()
      })
      await this.getById()
    },

    methods: {
      async getById() {
        const id = this.$route.params.id
        if (!id) {
          this.initialData = undefined

          return
        }

        try {
          const result = await this.rest[options.name].get(id)

          if (result) {
            this.initialData = cloneDeep(result)
          } else {
            this.initialData = undefined
          }
        } catch (error) {
          globalErrorHandler(error)
        }
      },

      async update() {
        if (this.updateDisabled) {
          return
        }

        try {
          const result = await this.rest[options.name].update(
            this.restData[options.name].get.data.id,
            this.restData[options.name].get.data
          )
          if (result) {
            this.initialData = cloneDeep(result)
            this.updateSuccessKey += 1
          }
        } catch (error) {
          globalErrorHandler(error)
        }
      },

      scrollToTop() {
        window.scrollTo({
          left: 0,
          top: 0
        })
      }
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
